<template>
    <el-dialog title="印章属性" class="customDialog attestationDialog" :visible="show" width="640px" append-to-body
        :close-on-click-modal="false" :before-close="closedBtn">
        <div class="dialog_main" v-if="sealInfo">
            <div class="tab_box">
                <div class="tab_item" @click="clickTab(index)" :class="{ active: activeName == index }"
                    v-for="(item, index) in ['基本信息', '详细信息']" :key="index">{{ item }}</div>
            </div>
            <div class="certificate_main" v-if="activeName == 0">
                <div class="info_box certificate_info">
                    <div class="info_main">
                        <ul>
                            <li>
                                <div class="info_lable">印章标识：</div>
                                <div class="info_content">{{ sealInfo.sealId }}</div>
                            </li>
                            <li>
                                <div class="info_lable">印章名称：</div>
                                <div class="info_content">{{ sealInfo.sealName }}</div>
                            </li>
                            <li>
                                <div class="info_lable">印章类型：</div>
                                <div class="info_content">{{ sealInfo.sealType }}</div>
                            </li>
                            <li>
                                <div class="info_lable">有效时间：</div>
                                <div class="info_content">从&nbsp;{{ sealInfo.validStart }}&nbsp;到&nbsp;{{
                                        sealInfo.validEnd
                                }}</div>
                            </li>
                            <li>
                                <div class="info_lable">制章日期：</div>
                                <div class="info_content">{{ sealInfo.signedDate }}</div>
                            </li>
                        </ul>
                        <div class="pic"><img :src="'data:image/png;base64,' + sealInfo.sealImage.pictureData" /><i class="sealIcon"></i></div>
                    </div>
                    <div class="button_info" @click="certificateBtn(1)">制章人证书</div>
                </div>
            </div>
            <div class="certificate_main" v-if="activeName == 1">
                <div class="info_box certificate_info">
                    <ul>
                        <li>
                            <div class="info_lable">印章类型：</div>
                            <div class="info_content">{{ sealInfo.sealType }}</div>
                        </li>
                        <li>
                            <div class="info_lable">印章版本：</div>
                            <div class="info_content">{{ sealInfo.version }}</div>
                        </li>
                        <li>
                            <div class="info_lable">厂商标识：</div>
                            <div class="info_content">{{ sealInfo.venderId }}</div>
                        </li>
                        <li>
                            <div class="info_lable">制章签名方法：</div>
                            <div class="info_content">{{ sealInfo.sealSignMethod }}</div>
                        </li>
                        <li>
                            <div class="info_lable">印章签名值：</div>
                            <div class="info_content">{{ sealInfo.sealSignature | ellipsis }}</div>
                        </li>
                    </ul>
                    <div class="button_info" @click="certificateBtn(2)">签章人证书列表</div>
                </div>

            </div>
            <div slot="footer" class="dialog-footer" style="text-align: right;">
                <el-button @click="closedBtn" size="small">&ensp;关闭&ensp;</el-button>
            </div>
        </div>
        <certificateInfo :overOnLine="overOnLine" :show.sync="certificateDialog" :title="certificateTitle" :seal-info-list.sync="certificateInfo" />
    </el-dialog>
</template>

<script>
import certificateInfo from "./certificateInfo.vue";
import { stringToByte, ByteToString } from '@comm/utils/tools'
export default {
    name: "sealPropertiesInfo",
    components: {
        certificateInfo
    },
    props: {
        show: { type: Boolean, default: false },
        sealInfo: { type: Object, default: null },
        overOnLine: { type: Boolean, default: false },
    },
    data() {
        return {
            key: "value",
            activeName: 0,
            certificateDialog: false,
            certificateInfo: [],
            certificateTitle:''
        };
    },
    watch: {
        sealInfo(val) {
            if (val.type == 'Sign' || val.type == 'TimeStamp') {
                this.certificateInfo = [this.sealInfo.signCert]
            } else {
                this.certificateInfo = this.sealInfo.certArray
            }
        }
    },
    filters: {
        ellipsis(value) {
            if (!value) return "";
            let bytes = ByteToString(stringToByte(Base64.decode(value)))
            return bytes;
        },
        // typeFilter(e) {
        //     switch (e) {
        //         case '1':
        //             return "文件预览"
        //         case '2':
        //             return "格式转换"
        //         case '3':
        //             return "签章验证"
        //     }
        // },
    },
    methods: {
        certificateBtn(type) {
            let certChain = [];
			this.sealInfo.sealCert.startTime = this.sealInfo.sealCert.start
			this.sealInfo.sealCert.endTime = this.sealInfo.sealCert.end
			this.sealInfo.signCert.startTime = this.sealInfo.signCert.start
			this.sealInfo.signCert.endTime = this.sealInfo.signCert.end
            if(type == 1){
                this.certificateTitle=''
				certChain = !this.sealInfo.sealCertChain||!this.sealInfo.sealCertChain.length ? [this.sealInfo.sealCert] : this.sealInfo.sealCertChain.slice().reverse()
			}else{
                this.certificateTitle='签章人证书'
				certChain = !this.sealInfo.signCertChain||!this.sealInfo.signCertChain.length ? [this.sealInfo.signCert] : this.sealInfo.signCertChain.slice().reverse()
			}
			this.certificateInfo = certChain
			this.timeInfo = this.sealInfo.timeInfo
			this.certificateInfo.forEach((item,index)=>{
					item.id = index + 1
					item.parentId = index == 0 ? null : index
					item.label = item.subjectInfo?item.subjectInfo.commonName:""
				})
            this.certificateDialog = true
        },
        clickTab(index) {
            this.activeName = index
        },
        handleOpened() {
            this.$refs.isleft.style = "transform: translateY(0px)";
        },
        closedBtn() {
            this.activeName = 0
            this.$emit("update:show", false);
        },
    }
};
</script>

<style lang="scss" scoped>
.dialog-scrollbar {
    height: 460px;
    width: 148px;
    overflow-x: hidden;
    background: #f5f7fa;
}


.tab_box {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .tab_item {
        font-size: 12px;
        color: #4F5D79;
        line-height: 16px;
        padding: 4px 12px;
        cursor: pointer;

        &.active {
            background: #14A8F0;
            border-radius: 12px;
            color: #fff;
        }
    }
}

.info_box,
.time_box {
    border-radius: 2px 2px 0px 0px;
    border: 1px solid #E4E6EB;
    height: 225px;
    overflow-y: auto;
    padding: 5px 8px 0;
    font-size: 12px;
    line-height: 18px;
}

.time_box {
    height: 106px;
    margin-top: 16px;
    padding: 8px 16px;
}

.dialog_main {
    position: relative;
    padding: 0 24px;
    height: 460px;
    width: 100%;

    .dialog-footer {
        position: absolute;
        right: 24px;
        bottom: 24px;
    }

    .info_box {
        ul li {
            font-size: 12px;
            line-height: 32px;
            padding: 0 8px;
            height: 32px;
            cursor: pointer;
            display: flex;
            align-items: center;

            &:hover {
                background: rgba(198, 206, 214, 0.2);
            }

            &:focus,
            &:active {
                background: rgba(198, 206, 214, 0.4);
            }

            &:first-child {
                cursor: default;
                color: #B7BFD0;

                &:hover,
                &:focus,
                &:active {
                    background: none;
                }
            }

            .info_lable {
                width: 88px;
                line-height: 23px;
                height: 32px;
            }

            .info_content {
                flex: 1;
                height: 35px;
                overflow-y: auto;
                display: block;
                line-height: 23px;
                height: 32px;

                &::-webkit-scrollbar {
                    display: none;
                }
            }
        }

        .info_main {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .pic {
                width: 146px;
                position: relative;

                img {
                    width: 100%;
                }
                .sealIcon{
                    display: block;
                    width: 120px;
                    height: 60px;
                    background: url(../../../../comm/images/document-conversion/electronic/seal_icon.png) 0 0 no-repeat;
                    background-size: 100%;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                }
            }

            ul {
                width: 410px;
            }
        }

        .button_info {
            font-size: 12px;
            text-decoration: underline;
            color: #14A8F0;
            line-height: 18px;
            margin-top: 32px;
            padding: 0 8px;
            cursor: pointer;
            display: inline-block;
        }
    }

    .certificate_info {
        ul li {
            color: #36425A;
            cursor: default;

            &:hover,
            &:focus,
            &:active {
                background: none;
            }

            &:first-child {
                color: #36425A;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/attestationPage/components/sealPropertiesInfo.vue